/**
 * @file
 * Attaches the behaviors for locations landing.
 */

(function (Drupal) {
  'use strict';

  Drupal.behaviors.locationContent = {
    attach(context) {
      const image = context.querySelector('.location-content__image');
      const map = context.querySelector('.location-content__map');

      if (image && map) {
        const toggleMedia = context.querySelector('.form-item--toggle');
        if (toggleMedia) {
          toggleMedia.addEventListener('change', (e) => {
            if (!e.target.checked) {
              image.classList.add('hidden');
              map.classList.remove('hidden');
            }
            else {
              image.classList.remove('hidden');
              map.classList.add('hidden');
            }
          });
        }
      }
      else {
        return;
      }
    }
  };
})(Drupal);
